import { createSelector } from "reselect";

const getSocketState = (state) => state.socket;

export const getSocketTopics = createSelector([ getSocketState ], socket => socket.topics);

export const getSocketMessage = createSelector([ getSocketState ], socket => socket.message);